var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.removeCountdown},[_c('svg',{attrs:{"height":"16","width":"16"}},[_c('circle',_vm._b({class:_vm.$style.ring,style:({ strokeDashoffset: _vm.strokePassedDashoffset }),attrs:{"transform":"rotate(90 8 8)"}},'circle',_vm.circleAttrs,false))]),_c('div',{class:_vm.$style.currentStep},[_vm._v(_vm._s(_vm.currentStep + 1))])])
}
var staticRenderFns = []

export { render, staticRenderFns }